import Vue from 'vue'
import Vuex from 'vuex'
import user from './store/user.js'
import permission from './store/permission.js'
import tagsView from './store/tagsView.js'
import breadcrubs from './store/breadcrub.js'
import guide from './store/guide.js'
import matchInfo from './store/matchInfo.js'
Vue.use(Vuex)
// 过滤左侧导航
function filterLayoutRoutes (routes) {
  const res = []
  routes.forEach(ele => {
    const tmp = { ...ele }
    if (tmp.hidden === false) {
      if (tmp.children) {
        tmp.children = filterLayoutRoutes(tmp.children)
      }
      res.push(tmp)
    }
  })
  return res
}
// 导航
const containerSlider = ['admin', 'levelunion', 'topunion']
// 面包屑权限
const containerBread = ['admin', 'levelunion', 'topunion']
export default new Vuex.Store({
  state: {
    slideToggle: false,
    image: '', // 上传的会员头像图片路径
    ossUrl: '', // oss图片资源访问路径
    matchResult: {
      groupList: [], // 比赛分组数据
      awardList: [] // 比赛获奖数据
    },
    numberOfMatch: 1, // 比赛名次
    topTitles: []
  },
  getters: {
    getImage (state) {
      return state.image
    },
    getOssUrl (state) {
      return state.ossUrl
    },
    getMatchResult (state) {
      return state.matchResult
    },
    getNumberOfMatch (state) {
      return state.numberOfMatch
    },
    visitedViews (state) {
      return state.tagsView.visitedViews
    },
    cachedViews (state) {
      return state.tagsView.cachedViews
    },
    peimissionRoutes (state) {
      if (!state.permission.routes) {
        return []
      }
      let layoutRoutes = filterLayoutRoutes(state.permission.routes)
      // 过滤父级 只展示第二级
      let resultRouter = []
      layoutRoutes.forEach(value => {
        value.children.forEach(route => {
          resultRouter.push(route)
        })
      })
      return resultRouter
    },
    shouldShowHeader (state) {
      let role = state.user.role
      return containerBread.indexOf(role) >= 0
    },
    shouldShowSlider (state) {
      let role = state.user.role
      return containerSlider.indexOf(role) >= 0
    },
    getBreadscrubs (state) {
      return state.breadcrubs.breadcrubs.filter((item, key) => {
        return key > 0
      })
    }
  },
  mutations: {
    changeSlide (state) {
      state.slideToggle = !state.slideToggle
    },
    changeImage (state, newImage) {
      state.image = newImage
    },
    changeOssUrl (state, url) {
      state.ossUrl = url
    },
    changeMatchResult (state, data) {
      state.matchResult = data
    },
    changeNumberOfMatch (state, data) {
      state.numberOfMatch = data
    },
    changeTopTitles (state, data) {
      state.topTitles = data
    }
  },
  actions: {
    commitChangeSlide (content) {
      content.commit('changeSlide')
    },
    commitChangeImage ({ commit }, newImage) {
      commit('changeImage', newImage)
    },
    commitChangeOssUrl ({ commit }, url) {
      commit('changeOssUrl', url)
    },
    commitChangeMatchResult ({ commit }, data) {
      commit('changeMatchResult', data)
    },
    commitChangeNumberOfMatch ({ commit }, data) {
      commit('changeNumberOfMatch', data)
    },
    commitChangeTopTitles ({ commit }, data) {
      commit('changeTopTitles', data)
    }
  },
  modules: {
    user,
    permission,
    tagsView,
    breadcrubs,
    guide,
    matchInfo
  }
})



// WEBPACK FOOTER //
// ./src/store.js